import clsx from 'clsx';

import type { ModalCommonProps } from './modal-types';
import { ModalStyles } from './modalStyles';

export const ModalBody = (props: ModalCommonProps) => {
  const { children, content = '', className = '' } = props;

  const bodyContent = content || children;

  return <div className={clsx(ModalStyles.body, className)}>{bodyContent}</div>;
};
